// Usa chartjs que está cargado globalmente
export const BACKGROUND_COLORS = [
  'rgba(255, 99, 132, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(255, 205, 86, 0.2)',
  'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(153, 102, 255, 0.2)',
  'rgba(201, 203, 207, 0.2)',
];
export const BORDER_COLORS = [
  'rgb(255, 99, 132)', 'rgb(255, 159, 64)', 'rgb(255, 205, 86)',
  'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(201, 203, 207)',
];

export default class ChartBarras {
  constructor(element, options = {}) {
    this.element = element;
    this.options = options;
    this.horizontal = this.options.horizontal || false;
  }

  // dataset será un array de arrays donde la primera posición es el label y la segunda el valor:
  // [[Profe1, 4], [Profe2, 6], [Profe3, 9]]
  setDataFromArray(dataset) {
    this.labels = dataset.map((dato) => dato[0]);
    this.data = dataset.map((dato) => dato[1]);
  }

  start() {
    /* global Chart, ChartDataLabels, I18n */
    this.chart = new Chart(
      this.element,
      {
        plugins: [ChartDataLabels],
        type: this.horizontal ? 'horizontalBar' : 'bar',
        data: {
          labels: this.labels,
          datasets: [{
            label: I18n.t('Total'),
            data: this.data,
            fill: false,
            backgroundColor: BACKGROUND_COLORS,
            borderColor: BORDER_COLORS,
            borderWidth: 1,
          }],
        },
        options: this.getChartOptions(),
      },
    );
  }

  update() {
    this.chart.data.labels = this.labels;
    this.chart.data.datasets[0].data = this.data;
    this.chart.update();
  }

  getChartOptions() {
    const options = {
      responsive: true,
      maintainAspectRatio: true,
      // aspectRatio: 1,
      title: { display: false },
      scales: {
        xAxes: [
          { display: false, gridLines: { display: false }, ticks: { beginAtZero: true } },
        ],
        yAxes: [
          { gridLines: { display: false } },
        ],
      },
      legend: { display: false },
      gridLines: { display: false },
      plugins: { datalabels: { anchor: 'end', align: 'start' } },
    };

    if (this.options.tooltips === false) {
      options.tooltips = { enabled: false };
    }

    if (this.horizontal === true) {
      options.scales = {
        xAxes: [
          { display: false, gridLines: { display: false }, ticks: { beginAtZero: true } },
        ],
        yAxes: [{ gridLines: { display: false } },],
      };
    } else {
      options.scales = {
        xAxes: [{ gridLines: { display: false } }],
        yAxes: [{ display: false, gridLines: { display: false }, ticks: { beginAtZero: true }, }],
      };
    }
    return options;
  }
}
